import React from 'react';
import { Card, Typography, Space, Button, Row, Col, Divider } from 'antd';
import { LinkOutlined, RobotOutlined, SettingOutlined, PlusOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const Skills = () => {
  const skills = [
    {
      id: 1,
      title: '水土保持审核技能',
      description: '基于AI的水土保持方案审核工具，帮助专业人员快速审核方案的合规性和完整性。',
      link: 'https://skillhub.cloud.tencent.com/skills/water-conservation-review',
      status: '已上线',
      tags: ['水土保持', '方案审核', 'AI辅助'],
    },
    {
      id: 2,
      title: '智能方案编写助手',
      description: '根据项目信息自动生成水土保持方案初稿，提高编写效率。',
      link: '#',
      status: '开发中',
      tags: ['方案编写', 'AI生成', '效率工具'],
    },
    {
      id: 3,
      title: '环境影响评估工具',
      description: '评估建设项目对环境的潜在影响，提供科学的分析报告。',
      link: '#',
      status: '规划中',
      tags: ['环境评估', '数据分析', '报告生成'],
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div>
          <Title level={2} style={{ marginBottom: '16px' }}>技能中心</Title>
          <Paragraph>
            技能中心汇聚了各种专业工具和AI能力，为水土保持工作提供全方位的技术支持。
            我们将不断更新和添加新的技能，以满足行业发展的需求。
          </Paragraph>
        </div>

        <Divider />

        <Row gutter={[16, 16]}>
          {skills.map((skill) => (
            <Col xs={24} sm={12} md={8} key={skill.id}>
              <Card
                hoverable
                style={{
                  height: '100%',
                  border: `1px solid ${skill.status === '已上线' ? '#52c41a' : skill.status === '开发中' ? '#1890ff' : '#d9d9d9'}`,
                }}
                actions={[
                  <Button
                    key="visit"
                    type="primary"
                    icon={<LinkOutlined />}
                    onClick={() => skill.link !== '#' && window.open(skill.link, '_blank')}
                    disabled={skill.link === '#'}
                  >
                    访问技能
                  </Button>,
                ]}
              >
                <Card.Meta
                  avatar={<RobotOutlined style={{ fontSize: '24px', color: '#1890ff' }} />}
                  title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span>{skill.title}</span>
                      <Text
                        style={{
                          color: skill.status === '已上线' ? '#52c41a' : skill.status === '开发中' ? '#1890ff' : '#d9d9d9',
                          fontWeight: 'bold',
                        }}
                      >
                        {skill.status}
                      </Text>
                    </div>
                  }
                  description={
                    <div>
                      <Paragraph style={{ marginBottom: '12px' }}>{skill.description}</Paragraph>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                        {skill.tags.map((tag, index) => (
                          <span
                            key={index}
                            style={{
                              padding: '2px 8px',
                              backgroundColor: '#f0f2f5',
                              borderRadius: '12px',
                              fontSize: '12px',
                              color: '#666',
                            }}
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  }
                />
              </Card>
            </Col>
          ))}

          {/* 占位卡片，用于未来添加新技能 */}
          <Col xs={24} sm={12} md={8}>
            <Card
              hoverable
              style={{ height: '100%', border: '1px dashed #d9d9d9', textAlign: 'center', padding: '40px 0' }}
            >
              <PlusOutlined style={{ fontSize: '48px', color: '#d9d9d9', marginBottom: '16px' }} />
              <Title level={4} style={{ color: '#d9d9d9' }}>即将上线</Title>
              <Paragraph style={{ color: '#999' }}>更多专业技能正在开发中，敬请期待！</Paragraph>
            </Card>
          </Col>
        </Row>

        <Divider />

        <div style={{ textAlign: 'center' }}>
          <Text type="secondary">
            技能数据来源于 SkillHub 及用户自主上传
          </Text>
          <br />
          <Button
            type="link"
            icon={<LinkOutlined />}
            onClick={() => window.open('https://skillhub.cloud.tencent.com', '_blank')}
          >
            访问 SkillHub 平台
          </Button>
        </div>
      </Space>
    </div>
  );
};

export default Skills;